import Constants from "./resources/Constants";

export const hasManagerCredentials = user => {
  return user.Perfil === Constants.PERFIL_GESTOR;
};

export const isContribuinte = user => {
  return user.Perfil === Constants.PERFIL_CONTRIBUINTE;
};